// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.countries', {
    url: '/countries',
    templateUrl: 'main/configuration/countries/countries.tpl.html',
    data: { pageTitle: 'Countries' },
  });
};

angular.module('configuration.countries', []).config(config);
